import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, Input, SimpleChanges } from '@angular/core';
import { Chart } from 'chart.js/auto';

@Component({
  selector: 'app-sales-chart',
  templateUrl: './sales-chart.component.html',
  styleUrls: ['./sales-chart.component.scss']
})
export class SalesChartComponent implements AfterViewInit{

  @Input() view: string = 'Monthly'; // Receive view type
  @Input() selectedYear: number = new Date().getFullYear(); // Receive selected year
  constructor(private http: HttpClient) {}

  chart: any;

  // Dynamic data
  totalAmount: number = 0;
  dateRange: string = '';

  // Load chart data when change occur in dashboard
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['view'] || changes['selectedYear']) {
      this.fetchData();
    }
  }

  //Load initial chart data
  ngAfterViewInit(): void {
    this.fetchData();
  }

  /**
   * Create Sales chart based on data
   * @param labels 
   * @param data 
   */
  createSalesChart(labels: string[], data: number[]): void {
    const ctx = document.getElementById('salesChart') as HTMLCanvasElement;
    // Destroy the previous chart before creating a new one
    if (this.chart) {
      this.chart.destroy(); 
    }

    // Check if only one data point exists and duplicate it for smooth line
    if (labels.length === 1) {
      labels.push(labels[0]); // Add duplicate label
      data.push(data[0]); // Add duplicate data point
    }

    this.chart = new Chart(ctx, {
      type: 'line',
      data: {
        labels: labels,
        datasets: [
          {
            data: data,
            borderColor: '#4f46e5',
            backgroundColor: 'rgba(79, 70, 229, 0.2)',
            fill: true,
            tension: 0.4,
          },
        ],
      },
      options: {
        responsive: true,
        plugins: {
          legend: {
            display: false,
          },
        },
        scales: {
          x: {
            display: true,
          },
          y: {
            display: true,
          },
        },
      },
    });
  }

  /**
   * Fetch data from api based on monthoy, quaterly yearly with year
   */
  fetchData(): void {
    let apiData;

    if(this.view === 'Monthly'){
      apiData = this.getMonthlyByYear(this.selectedYear);
    } else if(this.view === 'Quaterly'){
      apiData = this.getQuaterlyByYear(this.selectedYear);
    } else{
      apiData = this.getYearly();
    }

    this.extractData(apiData);
  }

  /**
   * Extract label and saled data form response
   * @param apiData label, daterange, sales data
   */
  extractData(apiData: any){
    this.totalAmount = apiData.totalAmount;
    this.dateRange = apiData.dateRange;

    // Extract labels and sales data
    // const labels = apiData.data.map((item: any) => item.label
    //   // item.month || item.quarter || item.year
    // );

    const labels = apiData.labels;
    // const salesData = apiData.data.map((item: any) => item.sales);
    const salesData = apiData.sales;
    // Update the chart with new data
    this.createSalesChart(labels, salesData);
  }

  //@Todo: Remove when api ready
  getQuaterlyByYear(year: any) {
    if (year == 2025) {
      return {
        "totalAmount": 14000,
        "dateRange": "Q1",
        "year": 2025,
        "labels": ["Q1"],
        "sales": [14000]
      };
    } else if (year == 2024) {
      return {
        "totalAmount": 700000,
        "dateRange": "Q1 - Q4",
        "year": 2024,
        "labels": ["Q1", "Q2", "Q3", "Q4"],
        "sales": [14000, 17000, 15000, 24000]
      };
    } else {
      return {
        "totalAmount": 32000,
        "dateRange": "Q1 - Q4",
        "year": 2023,
        "labels": ["Q1", "Q2", "Q3", "Q4"],
        "sales": [5000, 8000, 7000, 12000]
      };
    }
  }

  getMonthlyByYear(year: any){
    console.log("year: ", year);
  
    if (year == 2025) {
      return {
        totalAmount: 113200,
        dateRange: "January - March",
        year: 2025,
        labels: ["Jan", "Feb", "Mar"],
        sales: [610, 570, 590]
      }
      
    } else if (year == 2024) {
      return {
        totalAmount: 613200,
        dateRange: "January - December",
        year: 2024,
        labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        sales: [620, 570, 590, 500, 490, 520, 600, 620, 520, 540, 490, 520]
      }
    } else {
      return {
        totalAmount: 313200,
        dateRange: "January - December",
        year: 2023,
        labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        sales: [210, 470, 590, 400, 490, 520, 600, 620, 520, 540, 490, 520]
      };
    }
  }

  getYearly(){
    return {
      "totalAmount": 3528000,
      "dateRange": "2022 - 2025",
      labels: ['2022','2023','2024','2025'],
      sales: [1200,1500,1100,1600]
    };
  }
}
